import { isArray } from '@dimjs/lang';
import { hooks } from '@wove/react';
import { useRef } from 'react';

export const useArrayChange = <T>(dataList: Array<T>, forceUpdate = true) => {
  const changeListRef = useRef<Array<T>>(dataList);
  const update = hooks.useForceUpdate();
  const arrayOperate = {
    add: hooks.useCallbackRef((dataItem: T | Array<T>, isUnshift?: boolean) => {
      if (isUnshift) {
        const targetList = isArray(dataItem) ? dataItem : [dataItem];
        changeListRef.current = [...targetList, ...changeListRef.current];
      } else {
        changeListRef.current = changeListRef.current.concat(dataItem);
      }
      forceUpdate && update();
    }),
    update: hooks.useCallbackRef((index: number, dataItem: T) => {
      const target = changeListRef.current[index];
      if (target) {
        changeListRef.current[index] = { ...target, ...dataItem };
      }
      forceUpdate && update();
    }),
    delete: hooks.useCallbackRef((index: number) => {
      const deleteItem = changeListRef.current.splice(index, 1);
      forceUpdate && update();
      return deleteItem;
    }),
    resetList: hooks.useCallbackRef((dataList: Array<T>) => {
      changeListRef.current = dataList;
      forceUpdate && update();
    }),
    getList: hooks.useCallbackRef(() => {
      return changeListRef.current;
    }),
  };
  return [changeListRef.current, arrayOperate] as const;
};
